import GridTable from './GridTable';

export default GridTable;
